import { Drawer, IconButton } from '@mui/material';
import { RightDrawerProps } from 'types/molecules';
import customTwMerge from 'utils/twMerge';

export default function RightDrawer({
  isOpen = true,
  onClose,
  title,
  content,
  actions,
  disableBackdropClick,
  className,
  contentClassName,
}: RightDrawerProps) {
  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={isOpen}
      onClose={disableBackdropClick ? undefined : onClose}
      classes={{ paper: customTwMerge('w-[95%] max-w-[480px] rounded-l-[30px] shadow-2xl', className) }}
    >
      <div className="flex h-full flex-col">
        <div className="flex h-[80px] shrink-0 items-center justify-between bg-primary-300 px-9 text-headline20 text-neutral-0 shadow">
          <h3>{title}</h3>

          <IconButton onClick={onClose}>
            <img
              src={new URL('assets/svg/close.svg', import.meta.url).href}
              alt="close icon"
              className="w-5"
            />
          </IconButton>
        </div>

        <div className={customTwMerge('flex-1 overflow-y-auto px-5 py-4 shadow-sm', contentClassName)}>
          {content}
        </div>

        {actions && (
          <div className="mt-auto flex min-h-[68px] shrink-0 justify-center px-9 py-4 shadow">
            {actions}
          </div>
        )}
      </div>
    </Drawer>
  );
}
